<!--
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-05-25 19:05:44
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-05-22 14:29:38
 * @FilePath: \jyrg-web\src\views\mobile\home\index.vue
 * @Description: 群侠传移动端 - 首页
-->

<template>
 <div class="main-box">
  <div class="main">
    <div class="advert-base-map">
     <div class="advert-content">
      <div class="advert-home" @click="goHome()"></div>
           
     </div>
     <div class="award">
        <ul class="advert-ul">
          <li class="advert-li" >
            <div class="li-img"><img src="../../../assets/image/mb/advert/award/06.png" style="width: 100%; height: 100%;"/></div>
            <div class="li-title">*4000</div>
          </li>
          <li class="advert-li" >
            <div class="li-img"><img src="../../../assets/image/mb/advert/award/01.png" style="width: 100%; height: 100%;"/></div>
            <div class="li-title">*4000</div>
          </li>
          <li class="advert-li" >
            <div class="li-img"><img src="../../../assets/image/mb/advert/award/02.png" style="width: 100%; height: 100%;"/></div>
            <div class="li-title">*400</div>
          </li>
          <li class="advert-li" >
            <div class="li-img"><img src="../../../assets/image/mb/advert/award/05.png" style="width: 100%; height: 100%;"/></div>
            <div class="li-title">*40</div>
          </li>
      
          <li class="advert-li" >
            <div class="li-img"><img src="../../../assets/image/mb/advert/award/04.png" style="width: 100%; height: 100%;"/></div>
            <div class="li-title">*1</div>
          </li>
     
          <li class="advert-li" >
            <div class="li-img"><img src="../../../assets/image/mb/advert/award/03.png" style="width: 100%; height: 100%;"/></div>
            <div class="li-title">*1</div>
          </li>
        </ul>
     </div>
     <a href="https://downloads.qn1000a.com/GamePack/1724145909game_package340-3910.apk" v-show="devType==2"  @click="setDownload(1)"> <div class="download"></div></a>
     <a :href="urls.iosUrl" v-show="devType==1"  @click="setDownload(2)"> <div class="download"></div></a>
     <a :href="urls.pcUrl" v-show="devType==3"> <div class="download"  @click="setDownload(3)" ></div></a>
  
     <div class="contact">
      <div class="content-left">
        <div class="left-img"><img src="../../../assets/image/pc/wechat-code.jpg" style="width: 100%; height: 100%;" alt="QR Code" @longpress="recognizeQRCode" /></div>
      </div>
  
      <div></div>
     </div>
  
 
     <div class="download-home" v-show="isDownloadVisible">
        <div class="download-title">请前往官网下载</div>
        <div class="download-close">  <el-button type="primary" style="width: 66px;" @click="downloadClose()">确定</el-button></div>
      </div>

    </div>
  </div>
</div> 
</template>

<script>
import Html5Qrcode from "html5-qrcode";
import { mapActions } from "vuex";
import { Notify } from "vant";
import webSite from "../../../api/webSite";
export default {
  name: "Advert",
  metaInfo: {
    title: "《群侠传》",
  },
  data(){
    return{
      devType:2,
      bdVidVue:'',//推广百度参数
      urls: {},
      contactOne:'qxzshenfeng',
      contactTwo:'qunxiazhuan005',
      contactThree:'qunxiazhuan006',
      contactFor:'qunxiazhuan007',
      imageSrc: "/assets/image/mb/advert/qq-code.png", 
      isDownloadVisible: false,
    }
  },
  mounted() {
    this.getDeviceType();
    this.getUrls(); // 下载地址
    this.setOcpcAccess();//添加百度访问信息
  },

  methods: {
    ...mapActions({
      getDownloadUrl: "base/getDownloadUrl",
    }),
    getDeviceType() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
      this.devType=1;
    } else if (userAgent.match(/Android/i)) {
      this.devType=2;
      // const externalUrl = 'https://downloads.qn1000a.com/GamePack/1724145909game_package340-3910.apk';
      // window.location.href = externalUrl;
    }else{
      this.devType=3;
    }
  },
    //下载添加点击事件计数
    async setDownload(type) {
      let osType;
      if(type==1){
         osType="ANDROID";
      }else if(type==2){
        osType="IOS";
      }else{
        osType="PC";
      }
      let res = await webSite.setDownload(osType,this.bdVidVue);
    },
    //添加百度用户信息
    async setOcpcAccess() {
      let bdVid=this.$route.query.bd_vid;
      if(bdVid!=undefined){  
        if(bdVid){
        this.bdVidVue=bdVid;
        let params = {bdVid:bdVid};
        let res = await webSite.setOcpcAccess(params);
       }
    }
    },
    // 获取下载链接
    async getUrls() {
      const res = await this.getDownloadUrl(); // 下载地址
      this.urls = res;
    },
       // 进入官网
       goHome() {
      this.$router.push({ path: "/home" });
    },
    //开启设备是3的弹框
    async downloadVisible(){
      this.isDownloadVisible=true;
    },
  
    async downloadClose(){
      this.isDownloadVisible=false;
    },
  
        // 一键复制
   async copy(content) {
      try {
        let res = await this.$utils.doCopy(content);
        Notify({ type: "success", message: res });
        setTimeout(() => {
        }, 1000);
      } catch (error) {
        Notify({ type: "error", message: error });
      }
    },
    async recognizeQRCode(event) {
      event.preventDefault();
      try {
        const decodedText = await Html5Qrcode.decodeQrCode(event.target);
        console.log("QR Code recognized:", decodedText);
        // 处理识别结果
      } catch (error) {
        console.error("QR Code recognition error =", error);
        // 处理错误
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.main-box{
  position: relative;
  min-width: 1920px;
  background-color: #000;
  z-index: 1000;
.main {
  width:24%;
  height: 100vh;
  position: relative;
  overflow: auto;
  margin-left: 36%;
  // overflow: hidden; /* 防止滚动 */
  z-index: 1000;
  .advert-base-map {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height:1000px;
    background: url("~@/assets/image/mb/advert/advert-02.png");
    background-size: 100% 100%;
    .advert-content{
      width:380px;
      height:435px;

      .advert-home{
        width:150px;
        height:70px;
        position: absolute;
        margin-left: 2%;
        background: url("../../../assets/image/mb/advert/home-bt.png");
        background-size: 100% 100%;
      }
   
    }
    //award
    .award{
      width: 400px;
      height: 120px;
      background: url("../../../assets/image/mb/advert/award.png");
      background-size: 100% 100%;
      margin-bottom: 4%;

      .advert-ul{
        width:350px;
        height: 55px;
        margin: auto;
        // background-color: rgb(51, 0, 255);
        margin-top:12%;
        .advert-li{
          width: 35px;
          height: 45px;
          float: left;
          margin-left: 5%;
          // background-color: aqua;
          .li-img{
            width: 40px;
            height: 40px;
            // background-color: bisque;
          }
          .li-title{
            width: 35px;
            height: 13px;
            position: absolute;
            margin-top:-3%;
            text-indent:5ch;
            font-size: 14px;
            font-family: 字体一;
            font-weight: 800;
            // background-color: rgb(223, 25, 68);
          }
        }
      }
    }
    .download{
        width:260px;
        height:45px;
        background: url("../../../assets/image/mb/advert/download-01.png");
        background-size: 100% 100%;
        margin-bottom: 4%;
      }

    
    .contact{
      width:400px;
      height: 150px;
      background: url("../../../assets/image/mb/advert/content-01.png") no-repeat center;
      background-size: 100% 100%;
      .content-left{
        width: 165px;
        height: 130px;
    
        background-size: 100% 100%;
        float: left;
        .left-img{
          width: 120px;
          height:90px;
          margin-left:65%;
          margin-top:16%;
          //background: url("../../../assets/image/pc/wechat-code.jpg");
          background-size: 100% 100%;
        }
      }

    }

   
    .download-home{
      width:260px;
      height:65px;
      background-color: #ffff;
      position: absolute;
      top:420px;
      border-top-left-radius:5px;
      border-top-right-radius: 5px;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      .download-title{
        width: 100%;
        height: 25px;
        font-size: 14px;
        color: #000;
        text-align:center;
        line-height: 25px;
      }
      .download-close{
        width: 30px;
        height: 30px;
        margin: auto;
        // float: right;
        // margin-right:37%;
      }

    }
  }


}
}
</style>
